// headScripts.js

// --------------------
// FACEBOOK PIXEL
// --------------------
export const loadFacebookPixel = () => {
  if (window.fbq) return;

  (function(f,b,e,v,n,t,s){
    if(f.fbq)return;
    n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];
    t=b.createElement(e);t.async=!0;
    t.src=v;
    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);
  })(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', '2277106676000413');
  window.fbq('track', 'PageView');
};

// --------------------
// GOOGLE ANALYTICS
// --------------------
export const loadGoogleAnalytics = () => {

  const GA_IDS = [
    "G-D02PLBJZ73",
    "G-MR88JJTHE2"
  ];

  if (window.gtag) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_IDS[0]}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  window.gtag = gtag;

  gtag('js', new Date());

  GA_IDS.forEach(id => {
    gtag('config', id);
  });
};